import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";
import ItemService from "../../../services/human_resource_appCommonService";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../common/Validations";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import HRConstants from "../../../common/HRConstants";
import { getTaskList } from "../../../redux/feature/hr_app/hrSlice";
const TaskDelegationModal = React.forwardRef((props, ref) => {
  const documentNumber = props.taskNr;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [loading, setLoading] = useState(false);
  const [delegation, setDelegation] = useState();
   const [getEmpList, setEmpList] = useState([]);
  const [formInputs, setFormInputs] = useState({
    delegationDate: getTodaysData() || "",
    headerStatus: "Transferred",
  });

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    delegationDate: getTodaysData() || "",
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormInputs((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      // ✅ auto calculate remaining
      const allocated = Number(updated.allocatedAmount) || 0;
      const actual = Number(updated.actualAmount) || 0;

      updated.remainingAmount = allocated - actual;

      return updated;
    });
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
    const getEmpDrop = async () => {
    let obj4 = {
      type: "EMP",
    };
    await ItemService.getEmployeeDrop(obj4).then((item) => {
      if (item?.status === 200) {
        setEmpList(item?.data);
      } else {
        setEmpList([]);
        console.log(">> Error: Loading getEmpDrop");
      }
    });
  };
  useEffect(() => {
    getEmpDrop();
  }, []);
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };
  const delegationReason = [
    { id: 1, name: "Leave" },
    { id: 2, name: "Workload" },
    { id: 3, name: "Employee Unavailable" },
    { id: 4, name: "Shift Change" },
    { id: 5, name: "Department Change" },
    { id: 6, name: "Transfer" },
    { id: 7, name: "Skill Requirement" },
    { id: 8, name: "Urgent Requirement" },
    { id: 9, name: "Manager Request" },
    { id: 10, name: "Other" },
  ];
  const handleDelegationChange = (e) => {
    const { name, value } = e.target;

    setDelegation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (!getDropdownData) return;

    const { textField, name, code, employeeCode } = getDropdownData;

    if (textField === "newAssignedTo") {
      setDelegation((prev) => ({
        ...prev,
        newAssignedTo: name || "",
        newEmployeeCode: code || employeeCode || "",
      }));
    }

    if (textField === "delegationReason") {
      setDelegation((prev) => ({
        ...prev,
        delegationReason: name || "",
      }));
    }
  }, [getDropdownData]);
  const loadFirstLevelData = async (queryName) => {
    if (!documentNumber) return;
    setLoading(true);

    let obj = {
      queryName: "Get_HRTaskManage_Details",
      // documentNumber: documentNumber,
      documentNumber: props.taskNr,
    };

    try {
      const item = await ItemService.generateCustomerQuery(obj);
      const taskData = item?.data?.[0] || {};
      if (item?.status === 200) {
        // setFormInputs(taskData);
        setFormInputs({
          ...taskData,

          currentAssignedTo: taskData?.assignedTo || "",
          currentEmployeeCode: taskData?.employeeCode || "",
        });
        setDelegation({
          currentAssignedTo: taskData?.assignedTo || "",
          currentEmployeeCode: taskData?.employeeCode || "",
          delegationDate: getTodaysData() || "",
        });
      } else {
        setFormInputs([]);
        console.log(`>> Error: Loading ${queryName}`);
      }
    } catch (error) {
      console.error(`>> API Error: ${queryName}`, error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (documentNumber) {
      loadFirstLevelData("Get_HRTaskManage_Details");
    }
    // eslint-disable-next-line
  }, [documentNumber]);
  const handleUpdate = async () => {
    let obj = {
      ...formInputs,
      delegation: delegation,
      headerStatus: "Transferred",
    };
    setDisabled(true);

    try {
      const item = await ItemService.updateTask(obj);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        setFormInputs(
          item?.data?.length ? item.data : { ...formInputs, ...obj },
        );

        props.onHide();
        await dispatch(
          getTaskList({
            queryName: "Get_HRTaskManage_Details",
            module: "",
            page: 1,
            per_page: 10,
          }),
        );
        navigate(HRConstants.HR_TASK_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Task Delegation
          <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
            {documentNumber}
          </span>{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500 border-solid"></div>
          </div>
        ) : (
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TD</span>
                      </Col>
                      <Col xs={4} md={4} lg={4}>
                        <span className="headerTitle">
                          {" "}
                          Task Delegation Details
                        </span>
                        <span className="subHeaderTitle">
                          Task Delegation details
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div>
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  type="date"
                                  // label="Budget Date "
                                  label={
                                    <>
                                      <i className="bi bi-calendar-date labelIcon"></i>
                                      Delegation Date
                                    </>
                                  }
                                  name="delegationDate"
                                  id="delegationDate"
                                  value={formInputs?.delegationDate}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              {/* Current Assigned To - Disabled */}
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label={
                                    <>
                                      <i className="bi bi-person-check labelIcon"></i>
                                      Current Assigned To
                                    </>
                                  }
                                  name="currentAssignedTo"
                                  id="currentAssignedTo"
                                  value={formInputs?.currentAssignedTo || ""}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <ComboboxField
                                  label={
                                    <>
                                      <i className="bi bi-question-circle labelIcon"></i>
                                      Delegation Reason
                                    </>
                                  }
                                  placeholder="Select Reason"
                                  data={delegationReason}
                                  id="delegationReason"
                                  name="delegationReason"
                                  code="id"
                                  description="name"
                                  setValue={delegation?.delegationReason || ""}
                                  getvalue={setDropdownData}
                                  onChange={handleDelegationChange}
                                />
                              </Col>
                              {/* <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <ComboboxField
                                  label={
                                    <>
                                      <i className="bi bi-person-plus labelIcon"></i>
                                      New Assigned To
                                    </>
                                  }
                                  placeholder="Select Employee"
                                  data={employeeData}
                                  id="newAssignedTo"
                                  name="newAssignedTo"
                                  code="employeeCode"
                                  description="employeeName"
                                  setValue={delegation?.newAssignedTo || ""}
                                  getvalue={setDropdownData}
                                  onChange={handleDelegationChange}
                                />
                              </Col> */}
                                <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Assigned to"
                              label={
                                <>
                                  <i className="bi bi-person-check labelIcon"></i>
                                  Assigned to
                                </>
                              }
                              placeholder="Employee"
                              data={getEmpList}
                              id="newAssignedTo"
                              name="newAssignedTo"
                              code="newAssignedToCode"
                              description="newAssignedToDesc"
                              setValue={formInputs?.newAssignedTo}
                              getvalue={setDropdownData}
                              // onChangeValue={handleChangeCustomerContacts}
                            />
                          </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Remarks"
                                  label={
                                    <>
                                      <i className="bi bi-chat-left-text labelIcon"></i>
                                      Remarks
                                    </>
                                  }
                                  placeholder=""
                                  name="remarks"
                                  id="remarks"
                                  value={delegation?.remarks || ""}
                                  onChange={handleDelegationChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={12}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <FileUploadComponent
                                  id="supportingDocument"
                                  name="supportingDocument"
                                  label={
                                    <>
                                      <i className="bi bi-paperclip labelIcon"></i>
                                      Supporting Document
                                    </>
                                  }
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={formInputs?.supportingDocument || ""}
                                  onChange={handleDelegationChange}
                                />
                              </Col>
                              {/* <Col
                                xs={8}
                                md={2}
                                lg={2}
                                className="commLeftRightPadding"
                              >
                                {(formInputs?.supportingDocument && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs?.supportingDocument,
                                      )
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col> */}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {
                <Row className="my-4 ">
                  <Col
                    lg={{ span: 2, offset: 8 }}
                    className="d-flex justify-content-end mt-2"
                  >
                    <button
                      className="btnTable btn-danger"
                      onClick={handleCancel}
                      disabled={disabled}
                    >
                      Cancel
                    </button>
                  </Col>
                  <Col lg={2} className="d-flex justify-content-end mt-2">
                    <button
                      className="btnTable"
                      disabled={disabled}
                      onClick={handleUpdate}
                    >
                      Save
                    </button>
                  </Col>
                </Row>
              }
            </div>
          </div>
        )}
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
        />
      </Modal.Body>
    </Modal>
  );
});

export default TaskDelegationModal;
